import { handleActions } from 'redux-actions';
import { defaultChangePasswordWidgetState } from './defaults';
import { ChangePasswordWidgetData } from './types';
import { initSecurityPage } from '../../actions';
import {
  INITIAL_SAVE_REQUEST_META,
  makeSpecificSaveableWidgetDataMergeFunction,
  saveableWidgetRequestMetaReducer,
} from '../utils';
import {
  setChangePasswordWidgetCurrentPassword,
  setChangePasswordWidgetNewPassword,
  saveChangePassword,
  saveChangePasswordSuccess,
  saveChangePasswordFailure,
  setChangePasswordWidgetNewPasswordRepeat,
} from './actions';

const mergeChangePasswordWidgetDataChange = makeSpecificSaveableWidgetDataMergeFunction(
  defaultChangePasswordWidgetState
);

export default handleActions<ChangePasswordWidgetData, any>(
  {
    [initSecurityPage.toString()]: (state, action: ReturnType<typeof initSecurityPage>) => {
      const data: ChangePasswordWidgetData['initialData'] =
        defaultChangePasswordWidgetState.initialData;

      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setChangePasswordWidgetCurrentPassword.toString()]: (
      state,
      action: ReturnType<typeof setChangePasswordWidgetCurrentPassword>
    ) =>
      mergeChangePasswordWidgetDataChange(state, {
        currentPassword: action.payload.currentPassword,
      }),
    [setChangePasswordWidgetNewPassword.toString()]: (
      state,
      action: ReturnType<typeof setChangePasswordWidgetNewPassword>
    ) =>
      mergeChangePasswordWidgetDataChange(state, {
        newPassword: action.payload.newPassword,
      }),
    [setChangePasswordWidgetNewPasswordRepeat.toString()]: (
      state,
      action: ReturnType<typeof setChangePasswordWidgetNewPasswordRepeat>
    ) =>
      mergeChangePasswordWidgetDataChange(state, {
        newPasswordRepeat: action.payload.newPasswordRepeat,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveChangePassword,
      successAction: saveChangePasswordSuccess,
      failureAction: saveChangePasswordFailure,
      clearDataOnSuccess: true,
    }),
  },
  defaultChangePasswordWidgetState
);
